<template>
    <div class="addCategoriesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular
                class="mt-auto"
                :size="70"
                :width="7"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <div v-else  class="row">
            <div class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        :label="$t('board.label.table.nameCategory')"
                        color=secondary
                        v-model="formData.nombreCategoriaComercial"
                        readonly
                        disabled
                    ></v-text-field>
                    <v-text-field
                        :label="'*'+$t('board.label.nameSubCategory.title')" 
                        :placeholder="$t('board.label.nameSubCategory.text')" 
                        color=secondary
                        v-model="formData.nombre"
                        :counter="25"
                        :maxlength="25"
                        :rules="subcategoryRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        :label="'*'+$t('board.label.description.title')" 
                        :placeholder="$t('board.label.description.text')"
                        color=secondary
                        v-model="formData.descripcion"
                        :counter="40"
                        :maxlength="40"
                        :rules="descriptionRules"
                        required
                    ></v-text-field>
                    <v-text-field
                        :label="'*'+$t('board.label.mode.title')" 
                        color=secondary
                        v-model="formData.nombreModo"
                        readonly
                        disabled
                    ></v-text-field>
                </v-form>
                <div class="img-btn">

                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>{{ $t('button.update') }}</span>

                    </v-tooltip>  
                </div>

            </div>
        </div>
    </div>
</template>

<script>

    import Swal from "sweetalert2";
    import { mapActions, mapGetters} from "vuex";
    import  EventBus  from '@/utils/event_bus.js';
    import{
        BOARD_M,
        GET_STATE_LOADING,
        GET_MODO,
        ACTION_GET_MODE,
        ACTION_PUT_UPDATE_SUBCATEGORIES
    } from '@/views/categories_board/store/types/types.js'
    import i18n from '@/plugins/i18n';

    export default {
        name:"detailsCategoriesComponent",
        
        props: {
            subcategory: {
                required: true
            },
        },

        data() {
            
            return {
                formData: {
                    categoriaComercial:this.subcategory.idCategoria, 
                    nombreCategoriaComercial: this.subcategory.nombreCategoria,
                    idTipoProducto: this.subcategory.idTipoProducto,  
                    nombre: this.subcategory.nombreTipoProducto,
                    descripcion: this.subcategory.descripcion,
                    nombreModo: 'Pizarra',
                    modo:1    
                },
                subcategoryRules: [
                    v => !!v || this.$t('board.label.nameSubCategory.required')
                ],
                descriptionRules: [
                    v => !!v || this.$t('board.label.description.required')
                ],
                showErrorMessages: false
            };
        },
        async mounted() {

            // id del modo
            await this.getMode();
            const modos = await this.modes
            this.formData.modo = modos[1].idModoCategoria
        },

        methods: {

            ...mapActions({
                getMode: `${BOARD_M}${ACTION_GET_MODE}`,
                putUpdateSubCategoria: `${BOARD_M}${ACTION_PUT_UPDATE_SUBCATEGORIES}`,
            }),

            async submitForm() {
                // Validar el formulario antes de enviarlo
                const validationErrors = this.validateForm();

                // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                if (Object.keys(validationErrors).length > 0) {
                    const errorMessages = Object.values(validationErrors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.errorsValidation.plural.title'),
                        html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                        confirmButtonColor: '#6E17A5'
                    });
                    return;
                }

                //Si no hay errores de validación, imprime el formulario en la consola
                const update =  await this.putUpdateSubCategoria(this.formData);

                if(!update){
                    return Swal.fire({
                        icon: 'error',
                        title: i18n.t('label.invalid.title'),
                        text: i18n.t('label.invalid.text')
                    })
                }
                EventBus.$emit('update-subcategorie');
            },


            validateForm() {
                this.showErrorMessages = true;

                const errors = {};

                if (!this.formData.nombre || !this.formData.nombre.trim()) {
                    errors.nombre = this.$t('board.label.nameSubCategory.title');
                }

                if (!this.formData.descripcion || !this.formData.descripcion.trim()) {
                    errors.descripcion = this.$t('board.label.description.title');
                }
                
                return errors;
            },
        },
        computed: {
            ...mapGetters({
                modes: `${BOARD_M}${GET_MODO}`,
                loading: `${BOARD_M}${GET_STATE_LOADING}`,
            }),
        },
    }
</script>


<style lang="css" scoped>

    input[type="file"] {
        left: 0;
        top: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
    }

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 450px;

    }
    
    .row {
        display: flex;
        justify-content: center;
    }

    
    /*Resposive*/
    @media screen and (max-width: 1024px) {
        .col-md-7 {
            gap: 250px
        }
    }

    @media screen and (max-width: 768px) {
        .col-md-7 {
            display: flex;
            flex-direction: column;
            gap: 60px;
        }

    }


</style>